import './action_exports'
import './datastore_exports'
import './ts/cms_view';
import './ts/ui/attachment_ui'
import { toggle_pushpin_layer } from './ts/ui/menu/PushpinMenu'                  // AWH will be removed
import { Actions, Action } from './ts/redux/Actions'
import { AttachmentUi } from './ts/ui/attachment_ui';
import { build_num } from './ts/Version'
import { clean_raw_floorplan_data } from './ts/drawings/Drawing'
import { cleanup_workorders_data, Workorder, utilsWorkorderIcon, utilsWorkorderIsActive, utilsWorkorderType } from './ts/workorders/Workorder'
import { cms_logging } from './ts/cms_logging'
import { CmsApi } from './ts/cms_api'
import { Cookie } from './ts/Cookies'
import { dispatch_initializer, dispatch_action, Dispatcher } from './ts/redux/Dispatcher'
import { Id_asset, Id_floor, Id_building, Id_workorder, Id_location, Id_workorder_asset } from './ts/api/Identifiers'
import { initial_state } from './ts/InitialState';
import { initialize } from './ts/cms_view';
import { js_translate } from './ts/Geometry'
import { listener } from './ts/ui/listener'
import { MakeAssetsMenu, build_menu_content } from './ts/menu_data';
import { map_area_initialize, map_area_on_click } from './ts/ui/map/map_area'
import { Map, fromJS } from 'immutable'
import { MapMakeAttachmentsLayer } from './ts/map_attachments';
import { QueryString } from './ts/QueryString'
import { Reducer } from './ts/redux/Reducer'
import { SitemapUtils } from './ts/SitemapUtils'
import { State, get_state } from './ts/redux/State'
import { state_initializer } from './ts/redux/State'
import { temp_action_set_floorplan_data } from './ts/drawings/DrawingsReducers'
import { temp_get_drawing_from_id_drawing } from './ts/drawings/DrawingsCollection'
import { update_menu_workorders_content } from './ts/ui/menu/WorkordersMenu'   // AWH will be removed
import { WorkordersCollection } from './ts/workorders/WorkordersCollection'
import { message_event_listener } from './ts/ui/event_listener';

declare var require: any;

// FUNCTIONS
(window as any).MakeAssetsMenu = MakeAssetsMenu;
(window as any).MapMakeAttachmentsLayer = MapMakeAttachmentsLayer;
(window as any).datastore_menu__build_menu_content = build_menu_content;
(window as any).geometry__js_translate = js_translate;

(window as any).ui_attachments__update_map_url = AttachmentUi.update_map_url;
(window as any).ui_attachments__attachment_clicked = AttachmentUi.attachment_clicked;
(window as any).ui_attachments__open_360_link = AttachmentUi.open_link_clicked;


// temporary

// logging
(window as any).ts_temp__error = cms_logging.error;

// utils
(window as any).ts_temp__utilsWorkorderIsActive = utilsWorkorderIsActive;
(window as any).ts_temp__utilsWorkorderType = utilsWorkorderType;
(window as any).ts_temp__utilsWorkorderIcon = utilsWorkorderIcon;
(window as any).ts_temp__cleanup_workorders_data = cleanup_workorders_data;

(window as any).ts_temp__update_menu_workorders_content = update_menu_workorders_content;

(window as any).ts_temp__clean_raw_floorplan_data = clean_raw_floorplan_data;

(window as any).ts_temp__action_set_floorplan_data = temp_action_set_floorplan_data;
(window as any).ts_temp__get_data_for_drawing = temp_get_drawing_from_id_drawing;
// (window as any).ts_temp__get_a_default_drawing = temp_get_drawing_from_id_floor;
(window as any).ts_temp___build_num = build_num;

(window as any).ts_temp__get_js_array = function (imm_state: Map<any, any>, key: string, default_val: any): any {
    let state: State = State.wrap(imm_state);
    return state.get_array(key, default_val);
};

(window as any).ts_temp__querystring_get_id_customer = function () {
    let r: number = QueryString.id_customer;
    return r
};

(window as any).ts_temp__querystring_get_site_code = function () {
    let r: string = QueryString.customer_name;
    return r
};

(window as any).ts_temp__querystring_get_customer_name = function () {
    let r: string = QueryString.customer_name;
    return r
};

(window as any).ts_temp__querystring_get_id_segment = function () {
    let r: number = QueryString.id_segment;
    return r
};

(window as any).ts_temp__querystring_get_api_token = function () {
    let r: string = QueryString.api_token;
    return r
};

(window as any).ts_temp__querystring_get_api_gateway = function () {
    let r: string = QueryString.api_gateway;
    return r
};

(window as any).ts_temp__querystring_get_id_floor = function () {
    let r: Id_floor = QueryString.id_floor;
    if (r === null) {
        return null;
    }
    return r.value
};

(window as any).ts_temp__querystring_get_id_building = function () {
    let r: Id_building = QueryString.id_building;
    if (r === null) {
        return null;
    }
    return r.value
};

(window as any).ts_temp__sitemap_url = SitemapUtils.fetch_sitemap_url;

(window as any).ts_temp__api_DrawingLocations_GetAssetsByFloor = function (imm_state: Map<any, any>, dispatch_func: any, id_floor: string) {
    CmsApi.api_DrawingLocations_GetAssetsByFloor(Id_floor.wrap(id_floor));
};

(window as any).ts_temp__api_DrawingLocations_GetFindingsByFloor = function (imm_state: Map<any, any>, dispatch_func: any, id_floor: string) {
    CmsApi.api_roundingdrawinglocations_getfindingsbyfloor(Id_floor.wrap(id_floor));
};

(window as any).ts_temp__api_categories = function (imm_state: Map<any, any>, dispatch_func: any): void {
    CmsApi.api_categories();
};

(window as any).ts_temp__api_getattachmentsbylocation = function (imm_state: Map<any, any>, dispatch_func: any, id_floor: number | string): void {
    let id_location: Id_location = Id_location.wrap(id_floor)
    CmsApi.api_getattachmentsbylocation(id_location);
};

(window as any).ts_temp__api_get_workorders = function (imm_state: Map<any, any>, dispatch_func: any, workorder_query: any) {
    CmsApi.api_get_workorders(workorder_query);
};

(window as any).ts_temp__api_drawinglocations_f = function (imm_state: Map<any, any>, dispatch_func: any) {
    CmsApi.api_drawinglocations_f();
};

(window as any).ts_temp__api_drawinglocations_s = function (imm_state: Map<any, any>, dispatch_func: any) {
    CmsApi.api_drawinglocations_s();
};

(window as any).ts_temp__action_set_sitemap_url = function (old_state: Map<any, any>, data: any) {
    return Reducer.simple_reducer(State.wrap(old_state), Actions.ACTION_SET_SITEMAP_URL, data).toImmutable();
};

(window as any).ts_temp__action_set_sitemap_data = function (old_state: Map<any, any>, data: any) {
    return Reducer.simple_reducer(State.wrap(old_state), Actions.ACTION_SET_SITEMAP_DATA, data).toImmutable();
};

(window as any).ts_temp__action_set_drawings_info_data = function (old_state: Map<any, any>, data: any) {
    return Reducer.simple_reducer(State.wrap(old_state), Actions.ACTION_SET_DRAWINGS_INFO_DATA, data).toImmutable();
};

(window as any).ts_temp__reducer = function (old_state: Map<any, any>, action: string, data: any) {
    return Reducer.reducer(State.wrap(old_state), action, data).toImmutable();
};

(window as any).ts_temp__reducer_2 = function (old_state: Map<any, any>, new_state: Map<any, any>) {
    return Reducer.reducer_2(State.wrap(old_state), State.wrap(new_state)).toImmutable();
};

// awh todo: once the state moves completely over to Typescript, we can do away with the first parameter 
(window as any).get_raw_asset = function (state: Map<any, any>, id_asset: string): any {
    return State.wrap(state).assets.get_asset(Id_asset.wrap(id_asset)).raw;
};

// awh todo: once the state moves completely over to Typescript, we can do away with the first parameter 
(window as any).get_raw_workorder = function (state: Map<any, any>, id_workorder: string): any {
    let wos: WorkordersCollection = State.wrap(state).workorders;
    let wo: Workorder = wos.get_workorder(Id_workorder.wrap(id_workorder));
    if (wo === null) {
        console.error(`workorder ${id_workorder.toString()} not found`);
        return {};
    }
    return wo.raw;
};

// awh todo: once the state moves completely over to Typescript, we can do away with the first parameter 
(window as any).get_raw_workorder_for_multi_asset_workorder = function (state: Map<any, any>, id_workorder_asset: string): any {
    let wos: WorkordersCollection = State.wrap(state).workorders;
    let wo: Workorder = wos.get_workorder_from_multi_asset_id(Id_workorder_asset.wrap(id_workorder_asset));
    if (wo === null) {
        console.error(`workorder with id_workorder_asset ${id_workorder_asset.toString()} not found`);
        return {};
    }
    return wo.raw;
};

(window as any).is_debug_enabled = function (state: Map<any, any>): boolean {
    return State.wrap(state).is_debug;
};

(window as any).ts_temp__fetch_all = function (state: Map<any, any>, dispatch_func: any): void {
    CmsApi.fetch_all();
};

(window as any).ts_temp__initializer = function (get_imm_state_function: any, get_prev_imm_state_function: any, dispatch_function: any, dispatch_batch_function: any): void {
    state_initializer(get_imm_state_function, get_prev_imm_state_function);
    dispatch_initializer(dispatch_function, dispatch_batch_function);
};

(window as any).ts_temp__ui_listener = function (): void {
    listener();
};

(window as any).ts_temp__map_initializer = function (map_object: any, map_layers_object: any, ol_lib: any): void {
    map_area_initialize(map_object, map_layers_object);
    initialize(false);
};

(window as any).ts_temp__map_area_on_click = function (e: any): void {
    map_area_on_click(e);
};

(window as any).ts_temp__toggle_pushpin_layer = function (dispatch_func: any): void {
    toggle_pushpin_layer(dispatch_func);
};

(window as any).ts_temp__get_initial_state = function (): any {
    // return the initial state object as JSON
    return initial_state().toImmutable().toJS();
};

(window as any).ts_temp__cookeies_write = function (key: string, val: string) {
    Cookie.write(key, val);
};

(window as any).ts_temp__cookeies_read = function (key: string, val: string): any {
    // return the initial state object as JSON
    Cookie.read(key, null);
};

(window as any).ts_temp__cmsInputApiGateway = function (): string | null {
    // return the initial state object as JSON
    return QueryString.api_gateway;
};

(window as any).ts_temp__cmsInputToken = function (): string | null {
    // return the initial state object as JSON
    return QueryString.api_token;
};

(window as any).ts_temp__cmsInputSegmentId = function (): string | null {
    if (!QueryString.id_segment) {
        return null;
    }
    return QueryString.id_segment.toString();
};

(window as any).ts_temp__cmsInputSiteCode = function (): string | null {
    return QueryString.customer_name.toString();
};

(window as any).ts_temp__cmsInputCustomerId = function (): string | null {
    return QueryString.id_customer.toString();
};

(window as any).ts_temp__event_listener = function (event: MessageEvent) {
    message_event_listener(event);
};

(window as any).addEventListener('message', message_event_listener, false);

(window as any).ts_temp__get_list_of_workorders_on_current_floor = function (): any[] {
    let r = []
    let woc: WorkordersCollection = get_state().workorders.get_for_floor(get_state().id_floor);
    r = woc.toJSON();
    return r;
};

(window as any).dispatchWorkorderQuery = function (query: any): void {
    Dispatcher.dispatch_action(Action.set_workorder_query(query));
};

// DEBUG FUNCTIONS
(window as any).debug_current_query_string = function () {
    return get_state().current_query_string;
};


// DEBUG FUNCTIONS
(window as any).xxx = function () {
   // return get_state().current_query_string;
CmsApi.fetch_build_id();
};

// ES6 modules
const __cmsview_pathname = (window.location.pathname || '').toLowerCase();
const __cmsview_is_edit_page = __cmsview_pathname.indexOf('/edit/edit.html') !== -1;

if (__cmsview_is_edit_page) {
    require('../edit/js/cms_view_edit_view.js');
} else {
    require('../js/cms_view_map');
    require('../js/cms_view_mapcontrols');
    require('../js/cms_view_view');
}


// WEBPACK FOOTER //
// ./src/index.tsx